<template>
  <component
    :is="is"
    :class="[
      {
        btn: !theme.includes('link') && theme !== 'custom',

        'link p-0': theme === 'link',

        'h-8 min-h-0 p-2': theme.includes('icon'),
        'btn-ghost': theme === 'icon' || theme === 'ghost',
        'btn-primary': theme === 'icon-primary',

        'btn-primary group-hover:bg-primary-focus': theme === 'primary',
        'btn-addon group-hover:bg-addon-focus': theme === 'addon',
        'btn-accent group-hover:bg-accent-focus': theme === 'accent',
        'group-hover:bg-warning-focus btn-warning text-white': theme === 'warning',

        'btn-disabled': disabled || loading,

        rounded: rounded,

        'btn-wide': width === 'wide',
        'btn-block': width === 'block',

        'h-8 min-h-0': size === 'skinny',
        'btn-xs': size === 'xs',
        'btn-sm': size === 'sm',
        'btn-md': size === 'md',
        'btn-lg': size === 'lg',

        'no-animation': animation === 'none',
      },
    ]"
  >
    <slot />
  </component>
</template>

<script lang="ts" setup>
  import type { MButtonThemeProps } from '.';
  withDefaults(defineProps<MButtonThemeProps>(), {
    theme: 'primary',
    size: undefined,
    is: 'div',
    rounded: true,
  });
</script>

<style scoped>
  .btn,
  a.btn {
    @apply normal-case;
  }

  .btn.btn-disabled,
  .btn[disabled],
  .btn:disabled {
    @apply bg-base-300 text-white;
  }

  .btn-addon {
    @apply bg-slate-200 text-black;
  }
  .btn-addon:hover,
  .btn-addon:focus {
    @apply bg-slate-200;
  }
  .btn-addon:disabled {
    @apply bg-slate-200 text-opacity-100;
  }

  .link {
    @apply underline underline-offset-4;
  }

  .link:hover {
    @apply no-underline;
  }

  /**
  * This is a hack to make the link button work with flexbox.
  */
  a.link.btn-sm,
  a.link.btn-md,
  a.link.btn-lg,
  a.link.btn-xs {
    display: flex;
  }
</style>
